import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import { getZrmUserInfo } from '@zg-rentals/clickstream';
import type { ZrmClickstreamUserOrUndefined } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/3386
export const APPLY_NOW_CLICK_EVENT_TYPE_ID = '3386';
export const emitApplyNowClickEvent = (user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: APPLY_NOW_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'apply_now_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ApplyNow,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    ...getZrmUserInfo(user),
  });
